import { StatusType } from "hooks/usePayment";
import styled, { keyframes } from "styled-components";

export const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`

export const SkeletonBase = styled.div`
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200px 100%;
  animation: ${shimmer} 1.5s infinite;
  border-radius: 4px;
`

export const CircleSkeleton = styled(SkeletonBase)`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  flex-shrink: 0;
`

export const RectangleSkeleton = styled(SkeletonBase) <{ width?: string; height?: string }>`
  width: ${({ width }) => width || "100%"};
  height: ${({ height }) => height || "16px"};
`


export const EditButtonSkeleton = styled(SkeletonBase)`
  width: 28px;
  height: 28px;
  border-radius: 4px;
  flex-shrink: 0;
`


export const StatusSkeleton = styled(SkeletonBase)`
  width: 60px;
  height: 24px;
  border-radius: 6px;
`

export const Card = styled.div`
  background: white;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  position: relative;
  width: 100%;
`

export const PaymentStatusWrapper = styled.div`
  position: absolute;
  top: 11px;
  right: 10px;
`

export const UserIconWrapper = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 10px;
`

export const PaymentCard = styled(Card) <{ status?: StatusType, onClick?: () => void }>`
  padding: 10px
  gap: 16px;
  cursor: ${({ onClick }) => onClick ? "pointer" : "default"};
  border-width: 2px;
  border-color: ${({ status }) => (status === "success" ? "#15803D66" : "")};
`

export const DebtInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 6px;
  align-items: start;
`

export const PaymentIconWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 100px;
`

export const CardLastDigits = styled.span`
  font-size: 14px;
  color: #666;
  display: flex;
  align-items: center;
  gap: 6px;
`

export const PaymentInfo = styled.div`
  flex: 1;
`

export const PaymentDescription = styled.div`
  font-size: 14px;
  color: #6B7280;
`

export const EditButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  border-radius: 4px;
  
  &:hover {
    background: #f5f5f5;
  }
`

export const StyledBadge = styled.span<{ $status: StatusType }>`
  display: inline-flex;
  align-items: center;
  padding: 2.5px 8.5px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  
  ${({ $status }) => {
    switch ($status) {
      case "started":
        return `
      background-color: #fef3c7;
      color: #92400e;
      border: 1px solid #fcd34d;
    `;
      case "success":
        return `
      background-color: #dcfce7;
      color: #166534;
      border: 1px solid #bbf7d0;
    `;
      case "error":
        return `
      background-color: #fee2e2;
      color: #991b1b;
      border: 1px solid #fecaca;
    `;
      default:
        return `
      background-color: #f3f4f6;
      color: #6b7280;
      border: 1px solid #e5e7eb;
    `;
    }
  }}
`